"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ComponentContainer = require("../../../../Framework/ComponentContainer");
var _LicenseNotice = _interopRequireDefault(require("../../Components/LicenseNotice"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var mapStateToProps = function mapStateToProps(_ref) {
  var configurationMode = _ref.configurationMode;
  var selectedMode = configurationMode.selectedMode,
    licenses = configurationMode.licenses;
  return {
    Component: _LicenseNotice["default"],
    displayMissingLicenseNotice: !licenses.includes(selectedMode)
  };
};
var _default = exports["default"] = (0, _ComponentContainer.containerConnect)(mapStateToProps, null);